import styled from 'styled-components';
import { themeGet, is } from '@packages/ui';

export const NavigationUl = styled.ul`
  list-style-type: none;
  margin: 0;
  padding: 0;
  width: 100%;
  height: calc(100vh - 90px);
  /* IOS has problems with height calculation */
  @supports (-webkit-overflow-scrolling: touch) {
    height: calc(100vh - 204px) !important;
  }
  overflow-y: scroll;
`;

export const NavigationLi = styled.li<{ emphesize?: boolean }>`
  padding: 0;
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: ${themeGet.fontSize(6)};
  color: ${themeGet.colors('kilamanjaro')};
  padding: ${themeGet.space(3)};
  width: 100%;
  border-bottom: 1px solid ${themeGet.colors('swirl')};
  cursor: pointer;

  ${is('emphesize')`
      color: ${themeGet.colors('primary')};
      text-transform: uppercase;
  `};

  & > span {
    margin: 0 !important;
    padding: 0;
  }
  a {
    color: inherit;
  }
`;
